import React, { useState, useEffect } from "react";
import "../../Styles/Both.css";
import ApiService from "../../nhrc_apis/ApiService";

const { MembershipAPI, UploadAPI, AuthAPI } = ApiService;

function Both({ onBack, onComplete, memberId, membershipId }) {

  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= CAPTCHA ================= */
  const [captcha, setCaptcha] = useState({
    id: null,
    question: "",
  });

  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValid, setCaptchaValid] = useState(false);

  /* ================= FORM DATA ================= */
  const [formData, setFormData] = useState({
    collegeName: "",
    universityName: "",
    collegeCode: "",
    designation: "",
    department: "",
    state: "",
    district: "",
    pinCode: "",
    address: "",
    experience: "",
    idFront: null,
    idBack: null,
    officialEmail: "",
    personalEmail: "",
    password: "",
    confirmPassword: "",
    phone: "",
  });

  /* ================= CAPTCHA LOAD ================= */
  useEffect(() => {
    loadCaptcha();
  }, []);

  const loadCaptcha = async () => {
    try {
      const res = await AuthAPI.getCaptcha();

      setCaptcha({
        id: res?.data?.captcha_id,
        question: res?.data?.question,
      });

      setCaptchaInput("");
      setCaptchaValid(false);
    } catch {
      alert("Captcha load failed");
    }
  };

  /* ================= VERIFY CAPTCHA ================= */
  const verifyCaptcha = async () => {
    try {
      await AuthAPI.verifyCaptcha({
        captcha_id: captcha.id,
        answer: captchaInput,
      });

      setCaptchaValid(true);
      alert("Captcha Verified ✅");

    } catch {
      setCaptchaValid(false);
      alert("Invalid captcha ❌");
      loadCaptcha();
    }
  };

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  /* ================= FILE UPLOAD ================= */
  const uploadFile = async (file, type) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("membership_id", membershipId);
    fd.append("file_type", type);

    const res = await UploadAPI.uploadFile(fd);

    return res.data?.file_path || "";
  };

  /* ================= VALIDATION ================= */
  const validateForm = () => {
    const pinRegex = /^[0-9]{6}$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.collegeName) return alert("Enter College Name");
    if (!formData.universityName) return alert("Enter University Name");
    if (!formData.collegeCode) return alert("Enter College Code");
    if (!formData.designation) return alert("Enter Designation");
    if (!formData.department) return alert("Enter Department");

    if (!pinRegex.test(formData.pinCode))
      return alert("Invalid Pin Code");

    if (!phoneRegex.test(formData.phone))
      return alert("Invalid Phone Number");

    if (formData.password !== formData.confirmPassword)
      return alert("Passwords do not match");

    if (!captchaValid)
      return alert("Please verify captcha");

    if (!formData.idFront || !formData.idBack)
      return alert("Upload ID Proofs");

    return true;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const front = await uploadFile(formData.idFront, "representative_front");
      const back = await uploadFile(formData.idBack, "representative_back");

      /* 🔥 FINAL BACKEND PAYLOAD (FLAT FORMAT) */
      const payload = {
        member_id: memberId,
        membership_id: membershipId,

        college_name: formData.collegeName,
        university_name: formData.universityName,
        college_code: formData.collegeCode,
        designation: formData.designation,
        department: formData.department,
        state: formData.state,
        district: formData.district,
        pincode: formData.pinCode,
        university_address: formData.address,
        experience: formData.experience,
        mobile_number: formData.phone,

        official_mail_id: formData.officialEmail,
        personal_email: formData.personalEmail,
        password: formData.password,

        id_front: front,
        id_back: back,

        captcha_id: captcha.id,
        captcha_answer: captchaInput,
      };

      console.log("✅ FINAL PAYLOAD:", payload);

      await onComplete(payload);

      setShowPopup(true);

    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.detail || "Registration Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="repuni-container">

      {!showPopup ? (
        <div className="repuni-card">

          <h2 className="tpo-repuni-heading">
            REPRESENTATIVE UNIVERSITY / AUTONOMOUS DETAILS
          </h2>

          <form onSubmit={handleSubmit} className="tpo-repuni-form">

            <div className="repuni-grid">

              {/* ALL FIELDS SAME */}
              <div>
                <label>College Name*</label>
                <input name="collegeName" value={formData.collegeName} onChange={handleChange} />
              </div>

              <div>
                <label>University Name*</label>
                <input name="universityName" value={formData.universityName} onChange={handleChange} />
              </div>

              <div>
                <label>College Code*</label>
                <input name="collegeCode" value={formData.collegeCode} onChange={handleChange} />
              </div>

              <div>
                <label>Designation*</label>
                <input name="designation" value={formData.designation} onChange={handleChange} />
              </div>

              <div>
                <label>Department*</label>
                <input name="department" value={formData.department} onChange={handleChange} />
              </div>

              <div>
                <label>State*</label>
                <input name="state" value={formData.state} onChange={handleChange} />
              </div>

              <div>
                <label>District*</label>
                <input name="district" value={formData.district} onChange={handleChange} />
              </div>

              <div>
                <label>Pin Code*</label>
                <input name="pinCode" value={formData.pinCode} onChange={handleChange} />
              </div>

              <div>
                <label>Address*</label>
                <textarea name="address" value={formData.address} onChange={handleChange} />
              </div>

              <div>
                <label>Experience*</label>
                <input name="experience" value={formData.experience} onChange={handleChange} />
              </div>

              <div>
                <label>ID Front*</label>
                <input type="file" name="idFront" onChange={handleChange} />
              </div>

              <div>
                <label>ID Back*</label>
                <input type="file" name="idBack" onChange={handleChange} />
              </div>

              <div>
                <label>Official Email*</label>
                <input name="officialEmail" value={formData.officialEmail} onChange={handleChange} />
              </div>

              <div>
                <label>Personal Email*</label>
                <input name="personalEmail" value={formData.personalEmail} onChange={handleChange} />
              </div>

              <div>
                <label>Password*</label>
                <input type="password" name="password" value={formData.password} onChange={handleChange} />
              </div>

              <div>
                <label>Confirm Password*</label>
                <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} />
              </div>

              <div>
                <label>Phone*</label>
                <input name="phone" value={formData.phone} onChange={handleChange} />
              </div>

            </div>

            {/* CAPTCHA */}
            <div className="repuni-captcha">

              <label>{captcha.question}</label>

              <input value={captchaInput} onChange={(e) => setCaptchaInput(e.target.value)} />

              <button type="button" onClick={loadCaptcha}>Refresh</button>
              <button type="button" onClick={verifyCaptcha}>Verify</button>

              {captchaValid && <span style={{ color: "green" }}>✔</span>}
              {!captchaValid && captchaInput && <span style={{ color: "red" }}>✖</span>}

            </div>

            <div className="repuni-btn-row">

              <button type="button" onClick={onBack}>
                Back
              </button>

              <button type="submit" disabled={loading}>
                {loading ? "Registering..." : "Register"}
              </button>

            </div>

          </form>
        </div>
      ) : (
        <div className="repuni-popup-both">
          <h2>🎉 Success</h2>
          <p>Registration Completed Successfully</p>

          <button onClick={onBack}>Continue</button>
        </div>
      )}

    </div>
  );
}

export default Both;